export const userRoles = [
	{ value: 'admin', label: 'Admin' },
	{ value: 'organizationManager', label: 'Správce školy' },
	{ value: 'teamManager', label: 'Správce třídy' },
]
